import styles from "./adultcontent.module.scss";

const AdultContent = () => <div className={styles.adult}>18</div>;

export { AdultContent };
